// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import axios from 'axios'
import JsonBig from 'json-bigint'
// import BMap from 'vue-baidu-map'
import AMap from '@amap/amap-vue'
// import VueBMap from 'vue-bmap-gl'
import 'vue-bmap-gl/dist/style.css'
// import VueMapvgl from 'vue-mapvgl'
import { mapvgl } from 'vue-mapvgl/src/lib'
import * as echarts from 'echarts'
import VueClipboard from 'vue-clipboard2'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/global.css'
import 'mapbox-gl/dist/mapbox-gl.css'

// javascript
import store from '../src/store'
import http from './javascript/http'
import apiJs from './javascript/Api'
import leaflet from './javascript/leafletTest/test'
import permApi from './javascript/permApi'
// import BdMap from './javascript/Bdmap/mapLoader'
import GdMap from './javascript/GdMap/Controller'
import mapBox from './javascript/MapBox/Controller'
// import {dictionaries} from './javascript/dictionary'
import webSocket from './javascript/webSocket'
import devModelCtl from './javascript/function/devModelFuntion'
import accountFun from './javascript/function/accountFun'
import organizationFunction from './javascript/function/organizationFunction'
import getOrgTreeFunction from './javascript/function/getOrgTreeFunction'
import instructSendFunction from './javascript/function/instructSendFunction'
import trackingFunction from './javascript/function/trackingFunction'
import trackingFunctionLeafle from './javascript/function/trackingFunctionLeafle'
import cautionIconFun from './javascript/function/CautionIconFun'
import monitorLeaflet from './javascript/function/monitorLeaflet'

import deviceFunction from './javascript/function/deviceFunction'
import carSharingFun from './javascript/function/carSharingFun'
import replayFun from './javascript/function/replayFun'
import replayFunLeaflet from './javascript/function/replayFunLeaflet'
import caution from './javascript/function/CautionFun'
// 组件
import header from './components/layout/header'
import menu from './components/layout/menu'
// leaflet 测试
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet.pm'
import 'leaflet.pm/dist/leaflet.pm.css'
import 'leaflet.chinatmsproviders'
import 'leaflet-rotatedmarker/leaflet.rotatedMarker'
import 'leaflet.markercluster/dist/leaflet.markercluster.js'

import JsonViewer from 'vue-json-viewer'

import './javascript/dragDialog.js' // 拖拽弹窗，在需要用到拖拽功能的弹窗标签上加v-dialogDrag

import '@/assets/theme/index.css'// 自定义主题色

// 注册组件
Vue.component('my-header', header)
Vue.component('my-menu', menu)
Vue.L = Vue.prototype.$L = L
Vue.prototype.$store = store
Vue.prototype.$http = http
Vue.prototype.$apijs = apiJs
// 告警js
Vue.prototype.$caution = caution
Vue.prototype.$accountFun = accountFun
// 型号功能管理页js
Vue.prototype.$devModelCtl = devModelCtl
// 轨迹回放页js
Vue.prototype.$replayFun = replayFun
// 高精度轨迹回放页js
Vue.prototype.$replayFunLeaflet = replayFunLeaflet
// 共享车辆页面js
Vue.prototype.$carSharingFun = carSharingFun
// 告警设备图标匹配JS
Vue.prototype.$cautionIconFun = cautionIconFun
// 组织管理页js
Vue.prototype.$organizationFunction = organizationFunction
// 组织树js
Vue.prototype.$getOrgTreeFunction = getOrgTreeFunction
// 指令发送JS
Vue.prototype.$instructSendFunction = instructSendFunction
// 实时追踪接口功能JS
Vue.prototype.$trackingFunction = trackingFunction
Vue.prototype.$trackingFunctionLeafle = trackingFunctionLeafle
// 监控中心leaflet版本地图功能JS
Vue.prototype.$monitorLeaflet = monitorLeaflet
// 设备管理功能JS
Vue.prototype.$deviceFunction = deviceFunction
Vue.prototype.$leaflet = leaflet
Vue.prototype.$wsctr = webSocket
Vue.prototype.$permApi = permApi
// Vue.prototype.$dic = dictionaries
Vue.prototype.$axios = axios
// Vue.prototype.$bdmap = BdMap
Vue.prototype.$gdjs = GdMap
Vue.prototype.$mbjs = mapBox
Vue.prototype.$jsonBig = JsonBig
Vue.prototype.mapvgl = mapvgl
Vue.prototype.$echarts = echarts
axios.defaults.baseURL = '/apis'
axios.defaults.transformResponse = [
  function (data, headers) {
    if (headers['content-type'] === 'application/octet-stream') {
      return data
    } else {
      try {
        if (JSON.parse(data).code === 401) {
          sessionStorage.clear()
          this.$router.push('/')
        } else {
          try {
            const jsonbig = JsonBig({
              storeAsString: true
            })
            return jsonbig.parse(data)
          } catch (err) {
            return data
          }
        }
      } catch (err) {
        return data
      }
    }
  }
]
Vue.config.productionTip = false

// 众所周知，组件的默认props可以这么设置
ElementUI.Input.props.clearable.default = true
ElementUI.Dialog.props.closeOnClickModal.default = false
ElementUI.Dialog.props.closeOnPressEscape.default = false

Vue.use(ElementUI)
Vue.use(VueClipboard)
// Vue.use(BMap, {
//   ak: 'c2V1HpzVclCL981ycbxwPT54K1UVLWLw'
// })
// Vue.use(VueBMap)
// Vue.use(VueMapvgl)
// VueBMap.initBMapApiLoader({
//   ak: 'c2V1HpzVclCL981ycbxwPT54K1UVLWLw',
//   v: '1.0'
// })
Vue.use(AMap)

Vue.use(JsonViewer)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  if (from.path === '/expressway/bjpz') { // 如果路由发生变化判断信号
    Vue.prototype.$confirm('您确定要退出此页面?如果忘记保存，请点击【取消】按钮，保存后再退出！', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      next()
    })
  } else {
    next()
  }
})



// WEBPACK FOOTER //
// ./src/main.js